/**
 * Created by Pankaj on 05-Nov-2019
 */

import {RomanEmpireGameConfig} from "../../RomanEmpireGameConfig";
import {TimelineLite, TweenLite} from "gsap";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IShineMask} from "./RomanEmpirePolyBetLine";

export interface BitmapTextStyleData {
    fontName: string;
    fontSize?: number;
    align?: string;
    tint?: number;
    letterSpacing?: number;
    maxWidth?: number;
}

/**
* LineSprite class for Bet Line Sprites used in game
* common functionality can have on class.
*/

export class LineSprite extends PIXI.Sprite {
    constructor() {
        super();
        this.init();
    }

    private init() {
        this.anchor.set(0, 0);
    }
}


/**
* LineShine class : Shine animated on betlines.
* by using shine sprite
*/

export class LineShine extends PIXI.Sprite {
    constructor(texture : PIXI.Texture = GameResources.getTextures("shine")[0]) {
        super(texture);
        this.init();
    }

    private init() {
        this.anchor.set(0.5, 0.5);
        this.position.set(RomanEmpireGameConfig.instance.REEL_AREA_POS_X - 100, RomanEmpireGameConfig.instance.REEL_AREA_POS_Y);
        this.height = RomanEmpireGameConfig.instance.REEL_AREA_HEIGHT;
        this.visible = true;
        this.alpha = 1;
    }

    /**
    * Play function for play a shine on current bet line (still not used).
    */
    public play(): TimelineLite {
        let tl: TimelineLite | null = new TimelineLite();
        tl.add(TweenLite.fromTo(this, 0.5, {x: RomanEmpireGameConfig.instance.REEL_AREA_POS_X}, {
            x: RomanEmpireGameConfig.instance.REEL_AREA_POS_X + RomanEmpireGameConfig.instance.REEL_AREA_WIDTH,
            onComplete: () => {
                tl!.pause().kill();
                tl = null;
            }
        }), 0.5);
        return tl;
    }
}

/**
* LineShineMask class : create a mask for betline shine.
*/

export class LineShineMask extends PIXI.Sprite  {
    constructor(texture: PIXI.Texture, shineMaskPos : IShineMask) {
        super(texture);
        this.init(shineMaskPos);
    }

    private init(shineMaskPos : IShineMask){
        if(shineMaskPos){
            this.anchor.set(0, 0);
            this.position.set(shineMaskPos.x, shineMaskPos.y);
            this.scale.set(shineMaskPos.scaleX, shineMaskPos.scaleY);
            this.width = shineMaskPos.width;
            this.texture = GameResources.getTextures(shineMaskPos.textureStr)[0];
        }
    }
}

